var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyNotesPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.7202V1.27978C0 0.293544 0.955481 -0.320942 1.71631 0.175996L12.0052 6.89621C12.7602 7.38931 12.7602 8.61069 12.0052 9.10379L1.71631 15.824C0.955482 16.3209 0 15.7065 0 14.7202Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNotesPlay);
export default __webpack_public_path__ + "static/media/myNotesPlay.7db00d8f3bf8891532e9ab5a4e6b613f.svg";
export { ForwardRef as ReactComponent };